import React from 'react';

interface FollowUpPillProps {
  question: string;
  onFollowUpClick: (prompt: string) => void;
}

const FollowUpPill: React.FC<FollowUpPillProps> = ({
  question,
  onFollowUpClick,
}) => {
  if (!question) return null;

  return (
    <div className="mb-4 animate-fade-in">
      <p className="text-xs text-gray-600 mb-2 font-medium">🤔 Follow-up question:</p>
      <button
        onClick={() => onFollowUpClick(question)}
        className="w-full px-4 py-3 bg-white border-2 border-dashed border-green-400 text-green-800 rounded-lg text-sm font-medium text-left hover:bg-green-50 hover:border-green-500 transition-all duration-200 shadow-sm"
      >
        {question}
      </button>
    </div>
  );
};

export default FollowUpPill;
